import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class Breadcrumb extends Component {
  static propTypes = {
    links: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, url: PropTypes.string }))
  };

  render() {
    const { links } = this.props;

    return (
      <div className="grid-container-widescreen common-breadcrumb font-heading-lg margin-top-3 margin-bottom-3">
        {
          links.map((link, idx)=> {
            const { name, url } = link;
            if(idx + 1 === links.length) {
              return (
                <span key={`${idx}-${name}`}>{name}</span>
              )
            }

            return <span key={`${idx}-${name}`}><Link to={url}>{name}</Link> > </span>
          })
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Breadcrumb.js